function addScripts(key, callback) {
    if(key) {
        let googleReCaptchaUrl = `https://www.google.com/recaptcha/api.js?render=${key}`;

        if (!document.querySelectorAll(`[src="${googleReCaptchaUrl}"]`).length) {
            document.body.appendChild(Object.assign(
                document.createElement('script'), {
                    type: 'text/javascript',
                    src: googleReCaptchaUrl,
                    onload: callback
                })
            );
        }
    }
}

function apply(element, recaptchaKey) {
    let action = element.getAttribute('data-spam');
    let input = element.querySelector('[name="' + action + 'Value"]');

    grecaptcha.ready(function() {
        grecaptcha.execute(recaptchaKey, {action: action}).then(function(token) {
            if(input) {
                input.value = token;
            }
        });
    });
}

function getKey() {
    let recaptchaKey = document.querySelector('[data-spam-key]');
    return recaptchaKey ? recaptchaKey.getAttribute('data-spam-key') : null;
}


export function initialize() {
    let recaptchaKey = getKey();
    let areas = document.querySelectorAll('[data-spam]');

    if(recaptchaKey && areas.length) {
        addScripts(recaptchaKey, function() {
            areas.forEach(function(element) {
                apply(element, recaptchaKey);

                setInterval(function() {
                    apply(element, recaptchaKey);
                }, 45000);
            });
        });
    }
}
